import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BottomNav from './BottomNav';
import { AdUnit } from '@/components/common';
import { PageQualityProvider, usePageQuality } from '@/components/common/PageQuality';

export default function Layout() {
  return (
    <PageQualityProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-slate-900">
        <Header />
        <div className="flex pt-16">
          <main className="flex-1 min-h-[calc(100vh-4rem)] pb-16 lg:pb-0">
            <Outlet />
            <FooterAd />
            <Footer />
          </main>
        </div>
        <BottomNav />
      </div>
    </PageQualityProvider>
  );
}

/**
 * Footer ad — withheld on pages that declared themselves thin via <ThinPage />.
 * Serving ads against low-value pages is the specific behaviour AdSense's
 * "Low value content" policy penalises, so the suppression is not optional.
 */
function FooterAd() {
  const { isThin } = usePageQuality();
  if (isThin) return null;

  return (
    <div className="px-4 py-6 max-w-4xl mx-auto">
      <AdUnit slot="8901234567" format="horizontal" />
    </div>
  );
}
